import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getHasCard, getQuotedPriceList } from '@/api/miscellaneous';
import { getContact, login } from '@/api/miscellaneous';
import config from '@/config';
import userStoreModule from '@/store/modules/user';
import Cookies from 'js-cookie';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuotedPriceList',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const route = useRoute();
const list = ref<any[]>([]);
const images = ref([]);

const tel = ref(false);
const isShowTel = ref(false);

const restrictShow = ref(false);
const restrictCode = ref('');
const lineHeightArr = ref<any[]>([]);
const showCheckIn = ref<boolean>(false);

const curId = ref<any>('');
const purchaseId = ref<any>('');
const isRealName = ref(false);
const IsBaojia = ref(false);



onMounted(() => {
    let { id, purchaseid, state } = route.query;
    if (state) {
        const pramas = (state as string).split('split');
        id = pramas[0];
        purchaseid = pramas[1];
    }
    curId.value = id;
    purchaseId.value = purchaseid;

    getData({ id, purchaseid });
    showCheckIn.value = !Cookies.get('isSignIn');
});

const getData = (data?: any) => {
    const { id, purchaseid } = route.query;
    // if (!data || !id || !purchaseid) return;
    getQuotedPriceList(data || { id: id as string, purchaseid: purchaseid as string }).then(res => {
        list.value = res.items[0].purchaseItem;
        images.value = res.items[0].imgs;
    });
};

const call = (id: string): void => {
    purchaseId.value = id;

    getHasCard().then(res => {
        isRealName.value = !res;
        if (!res) {
            isRealName.value = true;
            return;
        } else {
            getContact({ id })
                .then(res => {
                    tel.value = res;
                    isShowTel.value = true;
                })
                .catch(e => {
                    let { code } = e;
                    if ([104, 105].includes(code)) {
                        restrictCode.value = code;
                        restrictShow.value = true;
                    } else if (code == 779) {
                        IsBaojia.value = true;
                    }
                });
        }
    });
};

const pagelogin = () => {
    let { code, id, purchaseid, state } = route.query;
    if (!code) {
        /**
         * 微信登录Code授权
         * 重定向页面还是这个页面，通过$router.query.code 判断是否是重定向回u来的
         * */
        const redirectUri = encodeURIComponent(`${config.webHost}${window.location.pathname}`);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.wechat.appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${id}split${purchaseid}#wechat_redirect`;
    } else {
        let [id, purchaseid] = (state as string).split('split');
        login({ code: code as string }).then(res => {
            let { token, encrypt } = res;
            userStoreModule.setToken(token);
            userStoreModule.setEncrypt(encrypt);
            // this.getDetail((state || id) as string);
            getData({ id, purchaseid });
        });
    }
};

const junmp = (url: string) => {
    window.location.href = url;
};

const test = (e: HTMLElement) => {
    if (!e) return;
    nextTick(() => {
        const { offsetHeight } = e;
        const line = Math.ceil(offsetHeight / Number(getComputedStyle(e).lineHeight.replace('px', '')));
        lineHeightArr.value.push({ line, showClosing: line > 2 });
    });
};
const classes = (idx: number) => {
    return {
        overflow: lineHeightArr.value[idx]?.showClosing,
    };
};
const show = (idx: number) => {
    lineHeightArr.value[idx].showClosing = !lineHeightArr.value[idx].showClosing;
};


const toQuotedPrice = () => {
    getHasCard().then(res => {
        console.log(res);
        isRealName.value = !res;
        if (!res) {
            isRealName.value = true;
            return;
        } else {
            router.push({ name: "QuotedPrice", query: { id: purchaseId.value, purchaseid: curId.value, } });
        }
    });
}
const cancelRealName = () => {
    isRealName.value = false;
}

const gotoRealName = () => {
    isRealName.value = false;
    router.push({ name: 'RealName', query: { id: curId.value, purchaseid: purchaseId.value, detailType: 'QuotedPriceList', back: 'true' } });
}

const cancelBaoJia = () => {
    IsBaojia.value = false;
}

const gotoBaoJia = (id: string) => {
    console.log(id);
    IsBaojia.value = false;
    router.push({ name: 'QuotedPrice', query: { id: purchaseId.value , purchaseid: curId.value, detailType: 'QuotedPriceList', back: 'true' } });

}


const __returned__ = { router, route, list, images, tel, isShowTel, restrictShow, restrictCode, lineHeightArr, showCheckIn, curId, purchaseId, isRealName, IsBaojia, getData, call, pagelogin, junmp, test, classes, show, toQuotedPrice, cancelRealName, gotoRealName, cancelBaoJia, gotoBaoJia, nextTick, onMounted, ref, useRouter, useRoute, getHasCard, getQuotedPriceList, getContact, login, config, userStoreModule, Cookies, moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})